import { Footer } from "../components/Footer"
import { MissingAccountInfo } from "../components/deposit/MissingAccountInfo"
export const MissingPage = () => {
    return (
        <div className="container">
            <MissingAccountInfo  />
            <Footer />
        </div>
    );
}